// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"1bd45a54","172":"082d385e","276":"028b6a1b","559":"047eecbd","914":"871b1057"}[chunkId] + ".chunk.css";
};